<template>
  <div>
    <div class="flex flex-col w-full h-auto mb-12">
      <div v-if=" item.status && item.status.name && item.status.name == 'Pending' && item.teleConsultant && currentUser._id && currentUser.type != 'Seller' && currentUser._id.toString() != item.teleConsultant._id.toString()" class="text-center bg-orange-100 border-t-4 border-b border-orange-500 text-orange-700 px-4 py-3" role="alert">
        <p class="text-sm font-bold">
          <span style="display: inline-block; width: 12px; height: 12px" class="pulse bg-warning"></span>
          Cette orders en cour de traitement par au autre post.
        </p>
        <p class="font-bold">
          Post: <i style="font-size: 12px" class="material-icons">person</i>
          {{ item.teleConsultant.fullName }}
        </p>
      </div>

      <div class="flex w-full h-auto justify-center items-center">
        <span class="Helvetica text-2xl font-bold text-primary-500 justify-center normal-case">{{
          $t('order_information') }}</span>
      </div>

      <div class="flex w-full h-auto justify-center items-center">
        <div class="flex w-full h-auto py-3 justify-end text-sm font-thin px-5">
        </div>
      </div>

      <div class="px-6">
        <div class="flex bg-white w-full space-x-2">
          <div class="flex w-full justify-between items-center shadow-xs h-auto p-6 my-1 mb-1 rounded-lg">
            <div class="flex w-full mt-1">

              <span class="rounded-full h-12 w-12 bg-gray-200">
                <i class="material-icons p-3 text-primary-400">person</i>
              </span>

              <div class="ml-5 w-full pb-4">
                <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                  {{ $t('customer_information') }}
                </div>

                <div class="text-sm font-light text-gray-500"></div>

                <div class="w-full space-y-4">
                  <div class="flex">
                    <div class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="customerFullName" class="bg-white text-gray-700 px-1">{{ $t('full_name') }}
                            <span :class="$colors.required">*</span></label>
                        </p>
                      </div>
                      <p>
                        <input :id="'customerFullName' + index" autocomplete="false" tabindex="0" type="text" v-model="item.customer.fullName" class="py-2 text-xs px-2 outline-none block h-full w-full" disabled />
                      </p>
                    </div>
                  </div>

                  <div class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                        <label for="customerPhone" class="bg-white text-gray-700 px-1">{{ $t('phone') }}
                          <span :class="$colors.required">*</span></label>
                      </p>
                    </div>
                    <p>
                      <input :id="'customerPhone' + index" autocomplete="false" tabindex="0" type="text" v-model="item.customer.phone" class="py-2 text-xs px-2 outline-none block h-full w-full" disabled />
                    </p>
                  </div>

                  <div class="border hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                        <label for="country" class="bg-white text-gray-700 px-1">{{ $t('country') }}</label>
                      </p>
                    </div>
                    <p>
                      <v-select v-model="item.customer.country" :options="options" v-bind:class="{ disabled: true }"
                        label="name">
                        <template slot="option" slot-scope="option">
                          <img class="flag-img" :src="$f.getCountryCode(option.code)" />
                          {{ option.name }}
                        </template>
                      </v-select>
                    </p>
                  </div>

                  <div class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                        <label for="city" class="bg-white text-gray-700 px-1">{{ $t('city') }}
                          <span :class="$colors.required">*</span>
                        </label>
                      </p>
                    </div>

                    <p class="inline-block width-90">
                      <v-select @input="setSelectedCity" v-model="item.customer.city" :options="cities" disabled></v-select>
                    </p>

                    <router-link :to="'/orders/edit/' + item._id + '?' + $f.objectToQueryLink($f.QueryStringToobject()) + '&index=' + item._id " class="inline-block cursor-pointer width-10 text-center">
                      <svg class="inline" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-3.994 12.964l3.106 3.105-4.112.931 1.006-4.036zm9.994-3.764l-5.84 5.921-3.202-3.202 5.841-5.919 3.201 3.2z" />
                      </svg>
                    </router-link>
                  </div>

                  <div v-if="currentUser.type !== 'Seller'" class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                        <label for="Frais" class="bg-white text-gray-700 px-1">{{ $t('shipping_cost') }}
                          <sup v-if="idWharhouse && idWharhouse.currency">({{ idWharhouse.currency }})</sup>
                        </label>
                      </p>
                    </div>

                    <p>
                      <input id="Frais" autocomplete="false" disabled tabindex="0" :value="item.feesShipp == -1 ? feesShipp.price : item.feesShipp" type="text" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                    </p>
                  </div>

                  <div class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                        <label for="customerAddress" class="bg-white text-gray-700 px-1">{{ $t('address') }}
                          <span :class="$colors.required">*</span></label>
                      </p>
                    </div>
                    <p>
                      <textarea :id="'customerAddress' + index" autocomplete="false" tabindex="0" type="text" v-model="item.customer.address" class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full" disabled></textarea>
                    </p>
                  </div>

                </div>
              </div>
              
            </div>
          </div>

          <!-- Order Information -->
          <div class="flex w-full justify-between items-center shadow-xs h-auto p-6 my-1 mb-1 rounded-lg">
            <div class="flex w-full mt-1">

              <span class="rounded-full h-12 w-12 bg-gray-200">
                <i class="material-icons p-3 text-primary-400">local_grocery_store</i>
              </span>

              <div class="ml-5 w-full pb-4">
                <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                  {{ $t('update_order_information') }}
                </div>

                <div class="text-sm font-light text-gray-500"></div>

                <div class="w-full space-y-4">
                  <!--  -->
                  <div class="flex">
                    <div class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="status" :style="{
                            borderColor: item.status ? item.status.color : '#000',}" class="bg-white text-gray-700 px-1">{{ $t('status') }}
                            <span :class="$colors.required">*</span>
                          </label>
                        </p>
                      </div>

                      <p>
                        <select name="status" autocomplete="type" :disabled="item.status && (item.status.name == 'Processed' || item.status.name == 'Delivered' || item.status.name == 'Confirmed' || item.status.name == 'To fulfill' || (item.status && item.status.name && item.status.name == 'Pending' && item.teleConsultant && currentUser._id && currentUser._id.toString() != item.teleConsultant._id.toString() && !['Admin', 'CEO'].includes(currentUser.type)))" v-bind:style="{ color: item.status ? item.status.color : '#000', borderColor: item.status ? item.status.color : '#000',}" v-model="item.status" class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white" @change="ChangeShipping()">
                          <option class="bg-white" selected :value="null">
                            {{ $t('status') }}
                          </option>
                          <option class="bg-white text-gray-600" v-for="(value, index) in statusOrder" :key="index" :value="value">
                            {{ value.name }}
                          </option>
                        </select>
                      </p>
                    </div>
                  </div>
                  <!--  -->

                  <div v-if="currentUser.type != 'Seller'" class="border hover:border-orange-400 w-full focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                        <label for="customerPhone" class="bg-white text-gray-700 px-1">Upsel
                        </label>
                      </p>
                    </div>
                    <p class="flex py-1 items-center justify-center w-full">
                      <label :for="'toogle' + item._id" class="cursor-pointer py-1">
                        <div class="relative">
                          <input :id="'toogle' + item._id" type="checkbox" class="hidden" v-model="item.upsel" />
                          <div class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                          <div :class="'toggle__dot-' + item._id" class="absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"></div>
                        </div>
                      </label>
                    </p>
                  </div>

                  <!--  -->
                  <div class="border hover:border-orange-400 w-full focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                    <!--  -->
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <!--  -->
                      <p>
                        <!--  -->
                        <label for="customerPhone" class="bg-white text-gray-700 px-1">
                          {{ 'already_confirmed' | t }}
                        </label>
                        <!--  -->
                      </p>
                      <!--  -->
                    </div>
                    <!--  -->

                    <!--  -->
                    <p class="flex items-center justify-center w-full">
                      <!--  -->
                      <label for="toogle3" class="cursor-pointer py-1">
                        <!--  -->
                        <div class="relative">
                          <!--  -->
                          <input id="toogle3" v-model="item.is_confirmed" disabled type="checkbox" class="hidden" />
                          <!--  -->
                          <div class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner" />
                          <!--  -->
                          <div class="toggle__dot-3 absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0" />
                          <!--  -->
                        </div>
                        <!--  -->
                      </label>
                      <!--  -->
                    </p>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                        <label for="customerPhone" class="bg-white text-gray-700 px-1">{{ $t('shipping_address') }}
                          <span :class="$colors.required">*</span></label>
                      </p>
                    </div>
                    <p>
                      <textarea v-if="item.status && item.status.name == 'Confirmed'" :id="'customerShippingAddress' + index" autocomplete="false" tabindex="0" type="text" v-model="item.customer.shippingAddress" class="py-2 text-xs px-2 outline-none block h-full w-full" disabled />
                      <textarea v-else :id="'customerShippingAddress' + index" autocomplete="false" tabindex="0" type="text" v-model="item.customer.shippingAddress" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                    </p>
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                      <p>
                        <label for="customerPhone" class="bg-white text-gray-700 px-1">{{ $t('comment') }}
                          <span :class="$colors.required"></span></label>
                      </p>
                    </div>
                    <p>
                      <textarea :id="'comment' + index" autocomplete="false" tabindex="0" type="text" v-model="item.comment" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                    </p>
                  </div>
                  <!--  -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Product Order -->
        <div class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
          <div class="flex w-full mt-1">
            <span class="rounded-full h-12 w-12 bg-gray-200">
              <i class="material-icons p-3 text-primary-400">local_mall</i>
            </span>

            <div class="ml-5 w-full pb-4">
              <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                {{ $t('order_products') }}
                <router-link :to="'/orders/edit/' + item._id + '?' + $f.objectToQueryLink($f.QueryStringToobject()) + '&index=' + item._id" class="inline-block cursor-pointer ml-2 text-center"><svg class="inline" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-3.994 12.964l3.106 3.105-4.112.931 1.006-4.036zm9.994-3.764l-5.84 5.921-3.202-3.202 5.841-5.919 3.201 3.2z" />
                  </svg>
                </router-link>
              </div>

              <div class="w-full space-y-4">
                <div class="w-full">
                  <table style="display: inline-table" class="w-full flex flex-row flex-no-wrap sm:bg-white rounded-md overflow-hidden sm:shadow-xs">
                    <thead class="text-white">
                      <tr class="bg-primary-400 flex flex-col flex-no wrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0">
                        <th class="p-2 justify-center">{{ $t('products') }}</th>
                        <th class="p-2 justify-center">{{ $t('quantity') }}</th>
                        <th class="p-2 justify-center">{{ $t('total') }}</th>
                      </tr>
                    </thead>

                    <tbody class="flex-1 sm:flex-none" v-for="it in item.details" :key="it._id">
                      <tr class="flex flex-col flex-no wrap sm:table-row mb-2 sm:mb-0">
                        <td class="border-grey-light text-xs justify-center border hover:bg-gray-100 p-2">
                          <div class="flex space-x-10">
                            <div>
                              <img alt="..." :src="it.product.picture || 'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg' " class="h-16 w-16 rounded-md mx-auto" />
                            </div>
                            <div>
                              {{ it.product.name }}
                              <p class="font-light">
                                {{ $t('price') }} : {{ it.product.price }}
                                <sup v-if="idWharhouse && idWharhouse.currency">({{ idWharhouse.currency }})</sup>
                              </p>
                            </div>
                          </div>
                        </td>
                        <td class="border-grey-light text-xs justify-center border hover:bg-gray-100 p-2 truncate">
                          {{ it.quantity }}
                        </td>
                        <td class="border-grey-light text-xs justify-center border hover:bg-gray-100 p-2 truncate">
                          {{ item.totalPrice }}
                          <sup v-if="idWharhouse && idWharhouse.currency">({{ idWharhouse.currency }})</sup>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Order Refund -->
        <div v-if="item.status && item.status.name == 'Return' && currentUser.type != 'Seller'" class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
          <div class="flex w-full mt-1">
            <span class="rounded-full h-12 w-12 bg-gray-200">
              <i class="material-icons p-3 text-primary-400">replay</i>
            </span>

            <div class="ml-5 w-full pb-4">
              <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                {{ $t('order_refunded_products') }}
              </div>

              <div class="w-full space-y-4">
                <div class="w-full">
                  <table style="display: inline-table" class="w-full flex flex-row flex-no-wrap sm:bg-white rounded-md overflow-hidden sm:shadow-xs">
                    <thead class="text-white">
                      <tr class="bg-primary-400 flex flex-col flex-no wrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0">
                        <th class="p-2 justify-center">{{ $t('products') }}</th>
                        <th class="p-2 justify-center">{{ $t('quantity') }}</th>
                        <th class="p-2 justify-center">
                          {{ $t('quantity_returned') }}
                        </th>
                      </tr>
                    </thead>

                    <tbody class="flex-1 sm:flex-none" v-for="it in item.details" :key="it._id">
                      <tr class="flex flex-col flex-no wrap sm:table-row mb-2 sm:mb-0">
                        <td class="border-grey-light text-xs justify-center border hover:bg-gray-100 p-2">
                          <div class="flex space-x-10">
                            <div>
                              <img alt="..." :src="it.product.picture ||
                                'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'
                                " class="h-16 w-16 rounded-md mx-auto" />
                            </div>
                            <div>
                              {{ it.product.name }}
                            </div>
                          </div>
                        </td>
                        <td class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate">
                          <b>{{ it.quantity }}</b>
                        </td>
                        <td class="border-grey-light text-xs justify-center border hover:bg-gray-100 p-2 truncate">
                          <div class="grid gap-4" :class="CheckQteDefecteuseorderexist ? 'grid-cols-2' : 'grid-cols-1'">
                            <div class="text-center bg-gray-200 px-6 py-3 border border-gray-300 text-left leading-4 text-primary-500 tracking-wider">
                              <b>{{ $t('ok_good') }}</b>
                            </div>
                            <div v-if="CheckQteDefecteuseorderexist" class="text-center bg-gray-200 px-6 py-3 border border-gray-300 text-left leading-4 text-primary-500 tracking-wider">
                              <b>{{ $t('defective') }}</b>
                            </div>
                            <input v-model="it.product.qteChange" :disabled="CheckQteDefecteuseorderexist" min="0" :max="it.quantity" type="number" class="border border-green-600 py-2 text-xs px-2 outline-none block h-full w-full" />
                            <div v-if="CheckQteDefecteuseorderexist" class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate">
                              <b>{{ it.quantity - it.product.qteChange }}</b>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div :id="item._id">
          <div v-if="item.status && item.status.name == 'Confirmed' && currentUser.type != 'Seller'" class="flex w-full justify-between shadow-xs items-center mt-5 h-auto p-6 my-1 mb-1 rounded-lg">
            <div class="flex w-full mt-1">
              <span class="rounded-full h-12 w-12 bg-gray-200">
                <i class="material-icons p-3 text-primary-400">local_shipping</i>
              </span>

              <!--  -->
              <div class="ml-5 w-full pb-4">
                <!--  -->
                <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                  {{ $t('shipping') }}
                </div>
                <!--  -->

                <!--  -->
                <div class="flex items-center gap-2 justify-between">
                  <!--  -->
                  <div class="w-full md:w-1/2">
                    <!--  -->
                    <div class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="customerAddress" class="bg-white text-gray-700 px-1">{{ $t('address_shipping')}}<span :class="$colors.required">*</span></label>
                        </p>
                      </div>
                      <p>
                        <textarea id="customerAddress" type="text" v-model="shipping.address" class="py-2 text-xs px-2 text-gray-900 outline-none block h-full w-full"></textarea>
                      </p>
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="w-full md:w-1/2">
                    <!--  -->
                    <div class="border h-16 hover:border-orange-400 focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="category" class="bg-white text-gray-700 px-1">Shipping date
                            <span :class="$colors.required">*</span></label>
                        </p>
                      </div>
                      <p>
                        <datetime-v2 type="datetime" v-model="shipping.date" :min-datetime="$moment(Date.now()).format('yyyy-MM-DD')" placeholder="Shipping date ..." input-class="py-2 text-xs px-2 outline-none block h-full w-full"></datetime-v2>
                      </p>
                      <input type="hidden" name="order" v-model="shipping.order" />
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div v-if="item.status && item.status.name == 'pending_unrached' && currentUser.type != 'Seller'" class="flex w-full justify-between shadow-xs items-center mt-5 h-auto p-6 my-1 mb-10 rounded-lg">
            <div class="flex w-full mt-1">
              <div class="border hover:border-orange-500 w-full focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <p>
                    <label for="reason" class="bg-white text-gray-700 px-1">Reason unreached
                      <span :class="$colors.required">*</span>
                    </label>
                  </p>
                </div>
                <p>
                  <select name="reason_unreached" v-model="item.reason_unreached" class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white">
                    <option class="bg-white" selected :value="null">
                      {{ $t('reason') }}
                    </option>
                    <option class="bg-white text-gray-600" v-for="(value, index) in resonU" :key="index" :value="value">
                      {{ value }}
                    </option>
                  </select>
                </p>
              </div>
            </div>
          </div>
          <!--  -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    config: { required: true, type: Object },
    item: { default: [] },
    shipping: { type: Object, default: null },
    statusOrder: { type: Array },
    zones: { type: Array },
    cities: { type: Array },
    courier: { type: Array },
    index: { type: Number },
    feesShipp: { type: Object },
    currency: { type: String },
    currentUser: { type: Object },
    CheckQteDefecteuseorderexist: { required: false },
    idWharhouse: { type: Object },
  },
  data() {
    return {
      typesShipp: ['normal', 'pendingChange', 'change'],
      options: this.$countries,
      resonU: ['Boite vocale', 'Ne répond pas', 'Or ligne'],
    };
  },
  async mounted() {
    this.shipping.order = this.item._id;
    await this.CheckQteDefecteuseOrder();
  },
  watch: {
    'item.status'(val) {
      if (val.name === 'Confirmed' || val.name === 'pending_unrached') {
        this.scrollTo(this.item._id);
      }
    },
    'item.reason_unreached'(val) {
      this.item.reason_unreached = val;
    },
    'item.teleConsultant'(val) {
      this.item.teleConsultant = val;
    },
    'item.upsel'(val) {
      this.item.upsel = val;
    },
    'item.is_confirmed'(val) {
      this.item.is_confirmed = val;
    },
  },
  methods: {
    scrollTo(hash) {
      location.hash = '#' + hash;
    },
    getCourierZone: function (val) {
      this.$emit('getCourierZone', val);
    },
    OrderChange: function () {
      this.$emit('OrderChange', this.index, this.item);
    },
    CheckQteDefecteuseOrder: function () {
      this.$emit('CheckQteDefecteuseOrder', this.item);
    },
    setSelectedCity: function (city) {
      if (city) {
        this.$emit('getFeesShippBycity', this.item.seller, city);
      }
    },
    async ChangeShipping() {
      if(this.item.status && this.item.status.name == 'Confirmed') {
        this.shipping.date =this.$moment().utcOffset(60).format('yyyy-MM-DDTHH:mm');
        this.shipping.address = this.item.customer.address;
      } else {
        this.shipping.date = null;
        this.shipping.address = null;
      }
    },
  },
};
</script>
